import Configuracoes from '../configuracoes/Configuracoes';
import style from './Header.module.css';
import Logo from "../logo/Logo";

const Header = ({
  className="", 
  noConfig=false,
  layout="default",
  accessLevel
}) => {

  return (
    
    <div className={`${style.header} ${className}`}>
      {/* <h3>Agenda APE</h3> */}
      <Logo className={style.logo} layout={layout} />

      {!noConfig && 
        <Configuracoes 
          className='configuracoes'
          accessLevel={accessLevel}
          layout={layout}
        />
      }
    </div>
  );
};

export default Header;
